var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2194 40.7873C45.8679 47.4339 47.3761 39.7445 51.6093 43.9746C55.6903 48.0546 58.0359 48.872 52.8652 54.0412C52.2176 54.5617 48.1025 60.8237 33.6408 46.3661C19.1774 31.9066 25.4358 27.7874 25.9565 27.1399C31.1396 21.9564 31.9429 24.3156 36.024 28.3955C40.2571 32.6275 32.5709 34.1406 39.2194 40.7873Z",
    fill: "#004F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.639dee0ae2b407ebda47ce069b28df0e.svg";
export { ForwardRef as ReactComponent };